<script setup lang="ts">
import { ref } from "vue";

import { configStore } from "@/stores/config";

import { useComponentErrorCapture } from "@/mixins/error";

useComponentErrorCapture();

const config = configStore();
let name = '';
try {
  name = await config.getDeviceName();
} catch (e) {
  console.error(e);
}
const remoteName = ref<string | null>(name || "");
const remoteIp = window.location.hostname;
config.$subscribe((mutation, state) => {
  if (state?.deviceMeta?.device_name) {
    remoteName.value = state.deviceMeta.device_name;
  }
});
</script>
<template>
  <h1 class="device-meta__name">{{ remoteName }}</h1>
  <div class="device-meta__host">{{ remoteIp }}</div>
</template>
